const NAVIGATION_SELECTOR = '[data-product-scroll-navigation]';
const INTENT_THRESHOLD = 8;
const INTENT_WINDOW = 120;
const DIRECTION_CHANGE_GUARD = 100;
const REVEAL_SCROLL_THRESHOLD = 16;
const REVEAL_CONFIRM_WINDOW = 180;
const OVERLAY_SELECTOR = [
  'dialog',
  '[role="dialog"]',
  '[aria-modal="true"]',
  '.modal',
  '.product-channel-modal',
  '.ro_search-modal'
].join(',');
const instances = new Map();

function getSectionRoot(navigation) {
  return navigation.closest('.shopify-section, [id^="shopify-section-"]');
}

function findNavigations(scope) {
  const navigations = [];
  if (scope instanceof Element && scope.matches(NAVIGATION_SELECTOR)) navigations.push(scope);
  if (scope.querySelectorAll) navigations.push(...scope.querySelectorAll(NAVIGATION_SELECTOR));
  return navigations;
}

function initializeWithin(scope) {
  findNavigations(scope).forEach(function (navigation) {
    const sectionRoot = getSectionRoot(navigation);
    if (!sectionRoot || instances.has(sectionRoot)) return;

    instances.set(sectionRoot, setupProductNavigation(sectionRoot, navigation));
  });
}

function cleanupSection(sectionRoot) {
  const cleanup = instances.get(sectionRoot);
  if (!cleanup) return;

  instances.delete(sectionRoot);
  cleanup();
}

function setupProductNavigation(sectionRoot, navigation) {
  const cleanups = [];
  const buyNowBtn = navigation.querySelector('#recommend-buy-now');
  let destroyed = false;

  sectionRoot.dataset.scrollNavInitialized = 'true';

  function addListener(target, type, listener, options) {
    target.addEventListener(type, listener, options);
    cleanups.push(function () {
      target.removeEventListener(type, listener, options);
    });
  }

  if (buyNowBtn) {
    addListener(buyNowBtn, 'click', function () {
      if (window.productChannelData && typeof window.productChannelData.openChannelModal === 'function') {
        window.productChannelData.openChannelModal('top navigation');
      }
    });
  }

  // === 下拉菜单初始化 ===
  (function initDropdown() {
    if (navigation.dataset.showProductSwitcher !== 'true') return; // 判断用户是否配置展示

    const trigger = navigation.querySelector('.recommend-dropdown-trigger');
    const menu = navigation.querySelector('.recommend-dropdown-menu');
    if (!trigger || !menu) return;

    // 后端 API 配置
    const countryCode = navigation.dataset.countryCode;
    const originHost = navigation.dataset.originHost;
    // const countryCode = 'ca';
    // const originHost = 'http://127.0.0.1:8001';
    // 当前页面处于 iframe 中时，URL 的域名部分设置为 Shopify 后台绑定的主域名（解决页面在 Shopify 后台传递给接口的域名问题）
    let url = window.location.href.split('?')[0];
    const isInIframe = window.self !== window.top;
    if (isInIframe) {
      const shopDomain = navigation.dataset.shopDomain || '';
      if (shopDomain) {
        const pathStart = url.indexOf('/', 8); // 跳过 'https://' 或 'http://'
        const pathname = pathStart >= 0 ? url.slice(pathStart) : '/';
        url = 'https://' + shopDomain + pathname;
      }
    }
    const newPageUrl = encodeURIComponent(url);
    const apiUrl = originHost + '/api/websiteSeries/getProductList?newPageUrl=' + newPageUrl;
    
    fetch(apiUrl, {
      method: 'GET',
      headers: { 'X-Country': countryCode }
    })
      .then(function (res) { return res.json(); })
      .then(function (res) {
        const data = (res && res.code === 0 && res.data) ? res.data : {};
        const currentProductName = data.showName || '';
        const seriesName = data.seriesName || '';
        const productList = Array.isArray(data.list) ? data.list : [];

        // 通过 for 循环动态渲染下拉选项（后端已排除当前产品）
        for (var i = 0; i < productList.length; i++) {
          var product = productList[i];
          var li = document.createElement('li');
          li.setAttribute('role', 'option');
          li.dataset.title = product.showName;
          li.dataset.url = product.newPageUrl;
          li.textContent = product.showName;
          li.setAttribute('v-track-click:click_navigation', JSON.stringify({
            module_name: 'top second pdp navigation',
            product_name: currentProductName,
            first_navigation: seriesName,
            title: product.showName,
          }));
          menu.appendChild(li);
        }

        // 没有同系列产品时，隐藏下拉箭头和下拉框，不绑定任何交互
        if (menu.children.length === 0) {
          var arrow = trigger.querySelector('.recommend-dropdown-arrow');
          if (arrow) arrow.style.display = 'none';
          trigger.removeAttribute('aria-haspopup');
          trigger.style.cursor = 'default';
          menu.remove();
          return;
        }

        function isOpen() {
          return trigger.getAttribute('aria-expanded') === 'true';
        }

        function open() {
          trigger.setAttribute('aria-expanded', 'true');
        }

        function close() {
          trigger.setAttribute('aria-expanded', 'false');
        }

        addListener(trigger, 'click', function (event) {
          event.preventDefault();
          if (isOpen()) {
            close();
          } else {
            open();
          }
        });

        addListener(menu, 'click', function (event) {
          const option = event.target.closest('[role="option"]');
          if (!option) return;
          const url = option.dataset.url;
          if (url) {
            window.location.href = url;
          }
        });

        addListener(document, 'mousedown', function (event) {
          if (!isOpen()) return;
          if (navigation.contains(event.target)) return;
          close();
        });

        addListener(document, 'keydown', function (event) {
          if (event.key !== 'Escape' || !isOpen()) return;
          close();
        });

        // 用户滚动时延迟关闭，避免 click 触发的微 scroll 事件误关
        let scrollCloseTimer = null;
        addListener(window, 'scroll', function () {
          if (!isOpen()) return;
          if (scrollCloseTimer !== null) clearTimeout(scrollCloseTimer);
          scrollCloseTimer = setTimeout(function () {
            scrollCloseTimer = null;
            close();
          }, 150);
        }, { passive: true });
      })
      .catch(function () {
        // 接口异常时静默失败：隐藏下拉箭头与下拉框
        var arrow = trigger.querySelector('.recommend-dropdown-arrow');
        if (arrow) arrow.style.display = 'none';
        trigger.removeAttribute('aria-haspopup');
        trigger.style.cursor = 'default';
        menu.remove();
      });
  })();

  const pageHeader = document.querySelector('.page-header');
  if (!pageHeader || document.documentElement.classList.contains('is-app')) {
    return cleanupWithoutScrollController;
  }

  let productHeaderHidden = pageHeader.classList.contains('product-scroll-nav-hidden');
  let externalHeaderHidden = pageHeader.classList.contains('ro_hide');
  let headerHeight = 0;
  let intentDirection = 0;
  let intentDistance = 0;
  let lastIntentAt = 0;
  let revealIntentUntil = 0;
  let lastObservedScrollY = window.scrollY;
  let upwardScrollDistance = 0;
  let upwardScrollAt = 0;
  let lastStateChangeAt = Number.NEGATIVE_INFINITY;
  let touchX = null;
  let touchY = null;
  let scrollFrame = null;
  let visualViewportFrame = null;
  let revealTimer = null;

  function isHeaderEffectivelyHidden() {
    return productHeaderHidden || externalHeaderHidden;
  }

  /**
   * A visible header must not be transformed: the navbar owns fixed-position mega panels,
   * and a transformed ancestor would change their containing block. While visible, the
   * visual viewport offset is applied through sticky top. Once hidden, the header can use
   * compositor translation safely; the secondary navigation always uses compositor movement.
   */
  function syncNavigationPosition() {
    const visualOffset = Math.max(0, window.visualViewport ? window.visualViewport.offsetTop : 0);
    const visualOffsetValue = `${visualOffset}px`;
    const headerHidden = isHeaderEffectivelyHidden();

    if (headerHidden) {
      pageHeader.style.removeProperty('--product-nav-visual-top');
      if (visualOffset > 0) {
        pageHeader.style.setProperty('--product-nav-visual-translate', `0 ${visualOffsetValue}`);
      } else {
        pageHeader.style.removeProperty('--product-nav-visual-translate');
      }
    } else {
      pageHeader.style.removeProperty('--product-nav-visual-translate');
      if (visualOffset > 0) {
        pageHeader.style.setProperty('--product-nav-visual-top', visualOffsetValue);
      } else {
        pageHeader.style.removeProperty('--product-nav-visual-top');
      }
    }

    sectionRoot.style.setProperty('--product-nav-visual-offset', visualOffsetValue);
    sectionRoot.style.setProperty('--product-nav-header-height', `${headerHeight}px`);
    sectionRoot.style.setProperty('--product-nav-offset', headerHidden ? `${-headerHeight}px` : '0px');
  }

  function syncHeaderMetrics() {
    headerHeight = pageHeader.getBoundingClientRect().height;
    syncNavigationPosition();
  }

  function resetIntent() {
    intentDirection = 0;
    intentDistance = 0;
    lastIntentAt = 0;
  }

  function clearRevealIntent() {
    revealIntentUntil = 0;
    if (revealTimer !== null) {
      clearTimeout(revealTimer);
      revealTimer = null;
    }
  }

  function clearUpwardScrollEvidence() {
    upwardScrollDistance = 0;
    upwardScrollAt = 0;
  }

  function clearRevealState() {
    clearRevealIntent();
    clearUpwardScrollEvidence();
  }

  function isRendered(element) {
    if (!element || element.getClientRects().length === 0) return false;
    const style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden';
  }

  function isNavigationBusy() {
    const navbar = pageHeader.querySelector('.ro-site-navbar');
    if (!navbar) return false;

    const navbarToggle = navbar.querySelector('.navbar-toggle');
    if (navbar.classList.contains('opened') && isRendered(navbarToggle)) return true;

    // PC 菜单关闭后会保留默认二级项的 opened/aria-expanded；仅可见的顶层菜单才算忙碌。
    const navMain = navbar.querySelector('.nav-main');
    if (
      navMain &&
      navMain.getAttribute('aria-hidden') !== 'true' &&
      navMain.querySelector(':scope > .nav-menu.l1.opened')
    ) {
      return true;
    }

    return Array.from(navbar.querySelectorAll('.nav-right [aria-expanded="true"]')).some(isRendered);
  }

  function setHeaderHidden(hidden, now, force) {
    const shouldHide = !!hidden;
    if (externalHeaderHidden) return false;
    if (shouldHide === productHeaderHidden) return true;
    if (shouldHide && isNavigationBusy()) return false;
    if (!force && now - lastStateChangeAt < DIRECTION_CHANGE_GUARD) return false;

    productHeaderHidden = shouldHide;
    lastStateChangeAt = now;
    clearRevealState();
    pageHeader.classList.toggle('product-scroll-nav-hidden', productHeaderHidden);
    syncHeaderMetrics();
    return true;
  }

  function confirmHeaderReveal(now) {
    if (!productHeaderHidden || externalHeaderHidden) {
      clearRevealState();
      return;
    }
    if (now > revealIntentUntil) clearRevealIntent();
    if (now - upwardScrollAt > REVEAL_CONFIRM_WINDOW) clearUpwardScrollEvidence();
    if (!revealIntentUntil || upwardScrollDistance < REVEAL_SCROLL_THRESHOLD) return;

    const guardRemaining = DIRECTION_CHANGE_GUARD - (now - lastStateChangeAt);
    if (guardRemaining > 0) {
      if (revealTimer === null) {
        revealTimer = setTimeout(function () {
          revealTimer = null;
          confirmHeaderReveal(performance.now());
        }, guardRemaining + 1);
      }
      return;
    }

    setHeaderHidden(false, now);
  }

  function requestHeaderReveal(now) {
    if (!productHeaderHidden || externalHeaderHidden || window.scrollY <= 1) return;

    revealIntentUntil = now + REVEAL_CONFIRM_WINDOW;
    confirmHeaderReveal(now);
  }

  function isInsideOverlay(target) {
    return target instanceof Element && !!target.closest(OVERLAY_SELECTOR);
  }

  function canConsumeScroll(element, direction) {
    if (element.scrollHeight <= element.clientHeight + 1) return false;

    const style = window.getComputedStyle(element);
    if (!/(auto|scroll|overlay)/.test(style.overflowY)) return false;

    if (direction > 0) {
      return element.scrollTop + element.clientHeight < element.scrollHeight - 1;
    }
    return element.scrollTop > 1;
  }

  function isInsideScrollableRegion(target, direction) {
    let element = target instanceof Element ? target : null;

    while (element && element !== document.body && element !== document.documentElement) {
      if (canConsumeScroll(element, direction)) return true;
      element = element.parentElement;
    }
    return false;
  }

  function registerIntent(direction, distance, target) {
    const now = performance.now();
    if (!direction || !distance || isInsideOverlay(target) || isNavigationBusy()) {
      resetIntent();
      clearRevealState();
      return;
    }
    if (isInsideScrollableRegion(target, direction)) {
      resetIntent();
      clearRevealState();
      return;
    }

    if (direction > 0) clearRevealState();

    if (direction !== intentDirection || now - lastIntentAt > INTENT_WINDOW) {
      intentDirection = direction;
      intentDistance = 0;
    }

    intentDistance += Math.abs(distance);
    lastIntentAt = now;
    if (intentDistance < INTENT_THRESHOLD) return;

    resetIntent();
    if (direction < 0) {
      requestHeaderReveal(now);
    } else if ((document.scrollingElement || document.documentElement).scrollHeight > window.innerHeight + 1) {
      setHeaderHidden(true, now);
    }
  }

  function normalizeWheelDelta(event) {
    if (event.deltaMode === WheelEvent.DOM_DELTA_LINE) return event.deltaY * 16;
    if (event.deltaMode === WheelEvent.DOM_DELTA_PAGE) return event.deltaY * window.innerHeight;
    return event.deltaY;
  }

  function handleWheel(event) {
    if (!event.isTrusted || event.ctrlKey) return;
    const delta = normalizeWheelDelta(event);
    registerIntent(delta > 0 ? 1 : delta < 0 ? -1 : 0, delta, event.target);
  }

  function handleTouchStart(event) {
    if (!event.isTrusted || event.touches.length !== 1) {
      touchX = null;
      touchY = null;
      clearRevealState();
      return;
    }
    touchX = event.touches[0].clientX;
    touchY = event.touches[0].clientY;
    resetIntent();
    clearRevealState();
  }

  function handleTouchMove(event) {
    if (!event.isTrusted || event.touches.length !== 1 || touchX === null || touchY === null) return;

    const nextX = event.touches[0].clientX;
    const nextY = event.touches[0].clientY;
    const deltaX = nextX - touchX;
    const deltaY = nextY - touchY;
    touchX = nextX;
    touchY = nextY;

    if (Math.abs(deltaY) <= Math.abs(deltaX)) return;
    registerIntent(deltaY < 0 ? 1 : -1, deltaY, event.target);
  }

  function resetTouch() {
    touchX = null;
    touchY = null;
    resetIntent();
  }

  function handleScroll() {
    if (scrollFrame !== null) return;
    scrollFrame = requestAnimationFrame(function () {
      scrollFrame = null;
      const now = performance.now();
      const currentScrollY = window.scrollY;
      const upwardDelta = lastObservedScrollY - currentScrollY;
      lastObservedScrollY = currentScrollY;

      if (upwardDelta > 0 && productHeaderHidden && !externalHeaderHidden) {
        if (now - upwardScrollAt > REVEAL_CONFIRM_WINDOW) upwardScrollDistance = 0;
        upwardScrollDistance += upwardDelta;
        upwardScrollAt = now;
      } else if (upwardDelta < 0) {
        clearRevealState();
      }

      if (window.scrollY <= 1 && productHeaderHidden && !externalHeaderHidden) {
        setHeaderHidden(false, now, true);
      } else {
        confirmHeaderReveal(now);
      }
    });
  }

  function handleVisualViewportChange() {
    if (visualViewportFrame !== null) return;
    visualViewportFrame = requestAnimationFrame(function () {
      visualViewportFrame = null;
      syncNavigationPosition();
    });
  }

  const resizeObserver = new ResizeObserver(syncHeaderMetrics);
  resizeObserver.observe(pageHeader);
  cleanups.push(function () {
    resizeObserver.disconnect();
  });

  const headerObserver = new MutationObserver(function () {
    const nextExternalHeaderHidden = pageHeader.classList.contains('ro_hide');
    if (nextExternalHeaderHidden !== externalHeaderHidden) {
      externalHeaderHidden = nextExternalHeaderHidden;
      lastStateChangeAt = performance.now();
      clearRevealState();
      if (externalHeaderHidden && productHeaderHidden) {
        productHeaderHidden = false;
        pageHeader.classList.remove('product-scroll-nav-hidden');
      }
      syncHeaderMetrics();
    }
    if (productHeaderHidden && !externalHeaderHidden && isNavigationBusy()) {
      setHeaderHidden(false, performance.now(), true);
    }
  });
  headerObserver.observe(pageHeader, {
    attributes: true,
    attributeFilter: ['class', 'aria-expanded'],
    subtree: true
  });
  cleanups.push(function () {
    headerObserver.disconnect();
  });

  addListener(window, 'wheel', handleWheel, { passive: true });
  addListener(window, 'touchstart', handleTouchStart, { passive: true });
  addListener(window, 'touchmove', handleTouchMove, { passive: true });
  addListener(window, 'touchend', resetTouch, { passive: true });
  addListener(window, 'touchcancel', resetTouch, { passive: true });
  addListener(window, 'scroll', handleScroll, { passive: true });
  if (window.visualViewport) {
    addListener(window.visualViewport, 'scroll', handleVisualViewportChange, { passive: true });
    addListener(window.visualViewport, 'resize', handleVisualViewportChange, { passive: true });
  }

  syncHeaderMetrics();
  requestAnimationFrame(function () {
    if (!destroyed) sectionRoot.classList.add('product-scroll-nav-ready');
  });
  return cleanup;

  function cleanupWithoutScrollController() {
    if (destroyed) return;
    destroyed = true;
    cleanups.forEach(function (remove) {
      remove();
    });
    delete sectionRoot.dataset.scrollNavInitialized;
  }

  function cleanup() {
    if (destroyed) return;
    destroyed = true;
    cleanups.forEach(function (remove) {
      remove();
    });
    if (scrollFrame !== null) cancelAnimationFrame(scrollFrame);
    if (visualViewportFrame !== null) cancelAnimationFrame(visualViewportFrame);
    clearRevealState();

    pageHeader.classList.remove('product-scroll-nav-hidden');
    sectionRoot.classList.remove('product-scroll-nav-ready');
    pageHeader.style.removeProperty('--product-nav-visual-top');
    pageHeader.style.removeProperty('--product-nav-visual-translate');
    sectionRoot.style.removeProperty('--product-nav-visual-offset');
    sectionRoot.style.removeProperty('--product-nav-header-height');
    sectionRoot.style.removeProperty('--product-nav-offset');
    delete sectionRoot.dataset.scrollNavInitialized;
  }
}

document.addEventListener('shopify:section:load', function (event) {
  if (event.target instanceof Element) initializeWithin(event.target);
});

document.addEventListener('shopify:section:unload', function (event) {
  const sectionId = event.detail && event.detail.sectionId;
  if (!sectionId) return;

  const sectionRoot =
    event.target instanceof Element && event.target.id === `shopify-section-${sectionId}`
      ? event.target
      : document.getElementById(`shopify-section-${sectionId}`);
  if (sectionRoot) cleanupSection(sectionRoot);
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    initializeWithin(document);
  }, { once: true });
} else {
  initializeWithin(document);
}
